import { Routes } from '@angular/router'
import { assetDetailsResolver } from 'src/app/core/resolvers/asset-details.resolver'
import { DetailsComponent } from './details.component'

export const DETAILS_ROUTES: Routes = [
  {
    path: ':assetId',
    component: DetailsComponent,
    resolve: {
      asset: assetDetailsResolver,
    },
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full',
  },
]
